import {CreateReducer} from '../utils/create_reducer';
import {GET_DASHBOARD_STATS,GET_CLERK_DASHBOARD_STATS,GET_PROVISIONAL_OFFER_STATS,CLEAR_DATA, GET_LAST_INSPECTIONS,GET_CUSTOMER_SERVICE_LIST_BY_DATE,GET_PROPERTY_VISIT_LIST_BY_DATE} from "../actions/dashboard_action";

const initState = {
    isDashBoardFetching:true,
    isClerkDashBoardFetching: true,
    isProvisionalOfferFetching:true,
    isLastInspectionFetching: true,
    isCSFetching:true,
    dashboardData:undefined,
    clerkDashboardData: undefined,
    provisionalOfferData: undefined,
    lastInspectionData: undefined,
    isPVFetching:true

};

const dashboardReducer = CreateReducer(initState, {
    [GET_DASHBOARD_STATS](state, action) {
        return {...state,dashboardData:action.payload,isDashBoardFetching: false}
    },
    [GET_CLERK_DASHBOARD_STATS](state, action) {
        return {...state,clerkDashboardData:action.payload,isClerkDashBoardFetching:false}
    },
    [GET_PROVISIONAL_OFFER_STATS](state, action) {
        return{...state, provisionalOfferData:action.payload, isProvisionalOfferFetching:false}
    },
    [GET_LAST_INSPECTIONS](state, action) {
        return{...state, lastInspectionData:action.payload, isLastInspectionFetching:false}
    },
    [GET_CUSTOMER_SERVICE_LIST_BY_DATE](state, action) {
        return {...state, customerServiceDataByDate: action.payload, isCSFetching: false};
    },
    [GET_PROPERTY_VISIT_LIST_BY_DATE](state, action) {
        return {...state, propertyVisitDataByDate: action.payload, isPVFetching: false};
    },
    [CLEAR_DATA](state,action){
        return {...initState};
    }
});

export default dashboardReducer;


// WEBPACK FOOTER //
// ./src/reducers/dashboard_reducer.js